import { createRoute, redirect } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';

export const Route = createRoute({
  path: '/memory-bank-notes',
  getParentRoute: () => pathlessAuthenticatedRoute,
  beforeLoad: () => {
    throw redirect({ to: '/settings/organization/memory-bank-notes' });
  },
});
